// all uploads
export const uploadItemsDefault = [];

// is busy
export const uploadIsBusyDefault = false;

// error
export const uploadErrorDefault = undefined;
